import React, { useEffect } from "react";
import {
  EmptyDocumentData,
  Folder,
  FolderBreadCrumbs,
} from "../../FileManager";
import { childFolderType } from "../../../redux/fileManager/fileManagerTypes";
import { folderType } from "../../../customHooks/FileManager/useFolderTypes";
type AppProps = {
  type: string | undefined;
  client_code: number;
  folder: folderType;
  fetching?: boolean;
  flag: boolean;
  setFlag: (data: boolean) => void;
  folderData: childFolderType[];
  renderDocumentList: any;
  filesData: any;
  handleUploadFile: (data: any) => void;
  childFiles: [];
  setFilesData: (data: any) => void;
  uploadData: any;
  setMultipleFileData: (data: any) => void;
  setSingleFolderData: (data: any) => void;
  singleFolderData: any;
  setCheckingBack: (data: any) => void;
  checkingBack: boolean;
  persistFolderData: any;
  multipleFileData: [];
  setPersistFolderData: (data: any) => void;
  setShowViewMoreFiles?: any;
  isFileAndFolderDelete?: boolean;
};
const RenderFileManager = ({
  type,
  client_code,
  folder,
  fetching,
  flag,
  setFlag,
  setFilesData,
  folderData,
  renderDocumentList,
  filesData,
  handleUploadFile,
  childFiles,
  setSingleFolderData,
  singleFolderData,
  setCheckingBack,
  checkingBack,
  persistFolderData,
  uploadData,
  multipleFileData,
  setMultipleFileData,
  setPersistFolderData,
  setShowViewMoreFiles,
  isFileAndFolderDelete,
}: AppProps) => {
  useEffect(() => {
    let newData = JSON.parse(JSON.stringify(filesData));
    newData?.map((item: any) => {
      item.isChecked = false;
    });
    setFilesData([...newData]);

    return () => setSingleFolderData({ folder_id: "0", folder_data: null });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (childFiles?.length > 0) {
      let newData = JSON.parse(JSON.stringify(childFiles));
      if (type === "invoice") {
        uploadData?.map((e: any) => {
          newData?.map((item: any) => {
            if (e?.file_url === item?.file_url) {
              item.isChecked = true;
            }
          });
        });
      } else {
        uploadData?.column_value?.map((e: any) => {
          newData?.map((item: any) => {
            if (e?.file_url === item?.file_url) {
              item.isChecked = true;
            }
          });
        });
      }

      setFilesData([...newData]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [childFiles]);

  useEffect(() => {
    if (childFiles?.length > 0) {
      let newData = JSON.parse(JSON.stringify(childFiles));

      if (type === "invoice") {
        multipleFileData?.map((e: any) => {
          newData?.map((item: any) => {
            if (e?.file_url === item?.file_url) {
              item.isChecked = true;
            }
          });
        });
      } else {
        multipleFileData?.map((e: any) => {
          newData?.map((item: any) => {
            if (e?.file_url === item?.file_url) {
              item.isChecked = true;
            }
          });
        });
      }

      setFilesData([...newData]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [childFiles]);

  return (
    <div className="content-area" style={{ height: "400px", overflow: "auto" }}>
      <div className="ml-2">
        <FolderBreadCrumbs
          type={type}
          client_code={client_code}
          folder={folder}
        />
      </div>

      {folderData?.length === 0 && !fetching && filesData?.length === 0 ? (
        <EmptyDocumentData
          type={type}
          toggleAddFolderModal={() => {}}
          handleUploadFile={handleUploadFile}
          imageWidth="25%"
          documentList={childFiles}
          client_code={client_code}
          isAddFolderPresent={false}
          isUploadPresent={false}
        />
      ) : (
        <>
          <div className="row m-0">
            <div className="col-md-12">
              <div className="row m-0">
                <div className="col-md-1"></div>
              </div>
              <div
                className="d-flex flex-row flex-wrap mb-4"
                style={{ margin: "-10px" }}
              >
                {folderData?.length > 0 &&
                  folderData?.map((childFolder: childFolderType) => {
                    return (
                      <Folder
                        key={childFolder.id}
                        folderId={childFolder.id}
                        folder={childFolder}
                        client_code={client_code}
                        type={type}
                        flag={flag}
                        setFlag={setFlag}
                        showViewMore={false}
                        setSingleFolderData={setSingleFolderData}
                        singleFolderData={singleFolderData}
                        setCheckingBack={setCheckingBack}
                        checkingBack={checkingBack}
                        persistFolderData={persistFolderData}
                        setPersistFolderData={setPersistFolderData}
                        isFileAndFolderDelete={isFileAndFolderDelete}
                      />
                    );
                  })}
              </div>
              {filesData?.length > 0 && (
                <>
                  <div
                    className="d-flex flex-row flex-wrap"
                    style={{ margin: "-10px" }}
                  >
                    {renderDocumentList()}
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RenderFileManager;
